/* unplugin-vue-components disabled */import { render } from "./contact-item.vue?vue&type=template&id=6cef35d1&scoped=true"
import script from "./contact-item.vue?vue&type=script&lang=js"
export * from "./contact-item.vue?vue&type=script&lang=js"

import "./contact-item.vue?vue&type=style&index=0&id=6cef35d1&scoped=true&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cef35d1"],['__file',"src/pages/pulse/tracker/contact-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cef35d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cef35d1', __exports__)) {
    api.reload('6cef35d1', __exports__)
  }
  
  module.hot.accept("./contact-item.vue?vue&type=template&id=6cef35d1&scoped=true", () => {
    api.rerender('6cef35d1', render)
  })

}


export default __exports__